/**
 * On a Store Analysis product row: a chip saying Fiona's packaging change is
 * in progress (or a remeasurement was requested), with its stage and next
 * check-in. It opens the Agents tab.
 * Only accepted cards whose check-in is still ahead show it (a due one is
 * back in the row's recommendations icon instead).
 */

import { Avatar, ButtonBase, Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";

import { AGENT_INFO, isFionaDecision } from "../../../constants";

import {
  formatFionaDate,
  getFionaTab,
  isRemeasurementCard,
  statusLabel,
} from "./fionaRules";

const FIONA_COLOR = AGENT_INFO.fiona.color;

// The in-progress Fiona card among a product's decisions, if any
const findInProgressFionaCard = (decisions) =>
  (Array.isArray(decisions) ? decisions : decisions ? [decisions] : []).find(
    (d) => isFionaDecision(d) && getFionaTab(d) === "open"
  ) || null;

const FionaInProgressChip = ({ decisions }) => {
  const navigate = useNavigate();
  const card = findInProgressFionaCard(decisions);
  if (!card) return null;
  const { status, show_again_at: checkIn } = card.fiona_card || {};
  return (
    <ButtonBase
      onClick={() => navigate("/sm-agents")}
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 1,
        mt: 1.5,
        py: 0.6,
        pl: 0.6,
        pr: 1.25,
        borderRadius: 4,
        backgroundColor: "#f5f6fc",
        border: "1px solid #d6daf0",
        maxWidth: "100%",
        textAlign: "left",
      }}
    >
      <Avatar
        src={AGENT_INFO.fiona.avatar}
        alt=""
        sx={{
          width: 22,
          height: 22,
          border: `2px solid ${FIONA_COLOR}`,
          backgroundColor: "#fff",
        }}
      />
      <Typography sx={{ fontSize: "0.75rem", color: "#283593" }}>
        <b>
          {isRemeasurementCard(card)
            ? "Remeasurement requested"
            : "Packaging change in progress"}
        </b>{" "}
        · {statusLabel(status)}
        {checkIn && ` · check-in ${formatFionaDate(checkIn)}`}
      </Typography>
      <Typography
        component="span"
        aria-hidden="true"
        sx={{ fontSize: "0.75rem", color: "#283593" }}
      >
        ›
      </Typography>
    </ButtonBase>
  );
};

export default FionaInProgressChip;
